module.exports = __webpack_public_path__ + "img/team.b4dcabf6.png";